import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import throttle from "lodash/throttle";
import { IProps, Option } from "./types";
import { Root, TagWithSx } from "./styles";

export default function SearchSelect({
  onChange,
  onInputChange,
  options = [],
  defaultValue = [],
  value = [],
  loading = false,
  sx,
}: IProps) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const throttledInputChange = React.useMemo(
    () =>
      throttle((value: string) => {
        onInputChange(value);
      }, 2000),
    []
  );

  return (
    <Root sx={sx}>
      <Autocomplete
        multiple
        sx={sx}
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option: Option) => option.name}
        options={options}
        loading={loading}
        value={value}
        defaultValue={defaultValue}
        onChange={(event, value, reason, details) => {
          if (reason === "removeOption" || reason === "selectOption") {
            onChange(value);
          }
        }}
        onInputChange={(event, value, reason) => {
          if (reason === "input") {
            throttledInputChange(value);
          }
        }}
        clearIcon={null}
        renderInput={(params) => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              placeholder: "Pesquise aqui...",
              endAdornment: (
                <>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            variant="standard"
          />
        )}
        renderTags={(value, getTagProps, ownerState) => {
          return (
            <>
              {value?.map((option: Option, index: number) => {
                const props = getTagProps({ index });
                return <TagWithSx label={option.name} {...props} key={props.key} />;
              })}
            </>
          );
        }}
      />
    </Root>
  );
}
